import axiosClient from './axiosClient';

const usersApi = {
  // Usuarios (solo administrador)
  getUsers: (params) => axiosClient.get('/users', { params }),
  createUser: (data) => axiosClient.post('/users', data),
  updateUser: (id, data) => axiosClient.put(`/users/${id}`, data),
  deleteUser: (id) => axiosClient.delete(`/users/${id}`),

  // Roles disponibles (cliente / administrador / tecnico)
  getRoles: (params) => axiosClient.get('/roles', { params }),
};

export default usersApi;
